import React, { ReactNode } from "react";
import classNames from "classnames";

interface Props {
  message?: string;
  extraClasses?: string;
  type?: string;
  icon?: boolean;
  shadow?: boolean;
  alignText?: string;
  testId?: string;
  children?: ReactNode;
}

const MessageBox: React.FC<Props> = ({
  message,
  extraClasses,
  type = "success",
  icon = true,
  shadow = true,
  children,
  alignText = "center",
  testId = "",
}: Props): JSX.Element => {
  const messageBoxClasses = classNames("message-box-wrapper", extraClasses, type, { "no-icon": !icon }, { "no-shadow": !shadow });
  const messageContentClasses = classNames("message-content", alignText);

  let mainMessage = null;
  if (message) {
    mainMessage = <span className="message-box-message" data-testid={testId}>
      {message}
    </span>;
  }

  return (
    <div className={messageBoxClasses}>
      <div className={messageContentClasses}>
        {mainMessage}
        {children}
      </div>
    </div>
  );
};

export default MessageBox;
